import api from './api';

export function generateAppQRCode(userId) {
    return api.get(`/generate-app-qr-code/${userId}`);
}

export function confirmSetup(params) {
    return api.post(`/confirm-setup`, params);
}